export class DebitProcessingFilterData {
  Processingdate?: string;
  DollarAmount?: number;
  ABAFinalised?: string;
  PeriodClosed?: string;
  UserName?: string;
}
